/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  AppliedStyling,
  AssignedLicensesResponse,
  BulkInviteRequest,
  BulkInviteResponse,
  BulkSendInviteNotificationsRequest,
  BulkUpdateUserIsSuperAdminRequest,
  BulkUpdateUserLicensesRequest,
  BulkUpdateUserLicensesRequestByFilter,
  BulkUpdateUserRolesRequest,
  BulkUpdateUserRolesRequestByFilter,
  BulkUpdateUserWorkspacesRequest,
  BulkWorkspaceReassignmentRequestByFilter,
  CallerRef,
  CheckLicenseUpdateResponse,
  CheckLicensesResponse,
  CheckTenantLicensesResponse,
  ConnectionStatus,
  CreateWorkspaceRequest,
  FavoriteMeetingTypes,
  ImageUploadRequest,
  ImageUrlResponse,
  IsAdmin,
  License,
  LicenseUsageResponse,
  MapString,
  MapUserIdPersonalDetails,
  MapUserIdString,
  MappingStatus,
  OrgBrandingPutRequest,
  PaginatedResultUMTUser,
  PaginatedResultUserAggregate,
  PaginatedResultUserChange,
  PaginatedResultWorkspaceListItem,
  PersonalDetails,
  PersonalPage,
  PersonalWorkspace,
  PublicTenantDetail,
  RecentWorkspaces,
  RequestLicenseRequest,
  RevisedOptionStyle,
  RevisedOrgBranding,
  RevisedWorkspaceBranding,
  RoleFilter,
  SelectWorkspaceRequest,
  Style,
  TenantDetail,
  UMTUser,
  UpaConfig,
  UpaLog,
  Update1,
  UpdateIsSuperAdminRequest,
  UpdateLicensesRequest,
  UpdateOnboardingStatusRequest,
  UpdateTenantRequest,
  UpdateUserRolesRequest,
  UpdateWorkspaceRequest,
  UserAggregate,
  UserIntegrationsResponse,
  UserProvisioningAutomation,
  ValidateEmailsRequest,
  ValidateEmailsResponse,
  Workspace,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "workspace";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description queries workspaces
   *
   * @tags Workspaces
   * @name Query
   * @request GET:/v1/tenant/{tenantId}/workspaces
   * @secure
   */
  query = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      id?: string[];
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, CreatedAt, UpdatedAt
       * @example "-Name"
       */
      ordering?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultWorkspaceListItem,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for query */
  queryPathGetter = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      id?: string[];
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, CreatedAt, UpdatedAt
       * @example "-Name"
       */
      ordering?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces`, query);

  /**
   * @description creates a workspace
   *
   * @tags Workspaces
   * @name Create
   * @request POST:/v1/tenant/{tenantId}/workspaces
   * @secure
   */
  create = (tenantId: string, data: CreateWorkspaceRequest, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for create */
  createPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces`);

  /**
   * @description attempts to find workspace specified by the id
   *
   * @tags Workspaces
   * @name GetWorkspace
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  getWorkspace = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspace */
  getWorkspacePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description updates workspace specified by the id
   *
   * @tags Workspaces
   * @name Update
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  update = (tenantId: string, workspaceId: string, data: UpdateWorkspaceRequest, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for update */
  updatePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description attempts to find personal workspace specified by the user id
   *
   * @tags Workspaces
   * @name GetPersonal
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/workspaces/personal
   * @secure
   */
  getPersonal = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalWorkspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/workspaces/personal`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPersonal */
  getPersonalPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/workspaces/personal`);

  /**
   * @description deletes workspace specified by the id
   *
   * @tags Workspaces
   * @name SoftDeleteWorkspace
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/soft
   * @secure
   */
  softDeleteWorkspace = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/soft`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for softDeleteWorkspace */
  softDeleteWorkspacePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/soft`);

  /**
   * @description attempts to find personal workspace specified by the user id
   *
   * @tags Public, Workspaces
   * @name PublicGetPersonalInternal
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/workspaces/personal
   */
  publicGetPersonalInternal = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalWorkspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/workspaces/personal`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publicGetPersonalInternal */
  publicGetPersonalInternalPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/workspaces/personal`);

  /**
   * @description attempts to find personal workspace specified by the user id
   *
   * @tags Guest, Workspaces
   * @name PublicGetPersonal
   * @request GET:/v1/guest-external/tenant/{tenantId}/user/{userId}/workspaces/personal
   * @secure
   */
  publicGetPersonal = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalWorkspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/user/${userId}/workspaces/personal`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publicGetPersonal */
  publicGetPersonalPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/user/${userId}/workspaces/personal`);

  /**
   * @description deprecated, use 'updateWorkspacesAssignedByFilterV2' - bulk updates user workspace assignments
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateWorkspaces
   * @request POST:/v1/tenant/{tenantId}/users/workspaces
   * @deprecated
   * @secure
   */
  updateWorkspaces = (tenantId: string, data: BulkUpdateUserWorkspacesRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/workspaces`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspaces */
  updateWorkspacesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/workspaces`);

  /**
   * @description deprecated, use 'updateWorkspacesAssignedByFilterV2' - bulk updates user workspace assignments by filter
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateWorkspacesAssignedByFilter
   * @request POST:/v1/tenant/{tenantId}/users/workspaces/by-filter
   * @deprecated
   * @secure
   */
  updateWorkspacesAssignedByFilter = (
    tenantId: string,
    data: BulkWorkspaceReassignmentRequestByFilter,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/workspaces/by-filter`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspacesAssignedByFilter */
  updateWorkspacesAssignedByFilterPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/workspaces/by-filter`, query);

  /**
   * @description Deprecated - use get user recent workspaces v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name GetRecentWorkspaces
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/workspaces/recent
   * @deprecated
   * @secure
   */
  getRecentWorkspaces = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      RecentWorkspaces,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/workspaces/recent`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRecentWorkspaces */
  getRecentWorkspacesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/workspaces/recent`);

  /**
   * @description Deprecated - use store user selected recent workspace v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name SelectWorkspace
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/workspaces/recent
   * @deprecated
   * @secure
   */
  selectWorkspace = (tenantId: string, userId: string, data: SelectWorkspaceRequest, params: RequestParams = {}) =>
    this.request<
      RecentWorkspaces,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/workspaces/recent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for selectWorkspace */
  selectWorkspacePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/workspaces/recent`);

  /**
   * @description Deprecated, use 'query users' - Query User Aggregate Table for fire admin UI
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindAll
   * @request GET:/v1/tenant/{tenantId}/users
   * @deprecated
   * @secure
   */
  findAll = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUserAggregate,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAll */
  findAllPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users`, query);

  /**
   * @description Deprecated, use 'remove users by filter' - Removes users
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name BulkRemove
   * @request DELETE:/v1/tenant/{tenantId}/users
   * @deprecated
   * @secure
   */
  bulkRemove = (
    tenantId: string,
    query?: {
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkRemove */
  bulkRemovePathGetter = (
    tenantId: string,
    query?: {
      id?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users`, query);

  /**
   * @description Deprecated, use 'query users' - Query User Aggregate Table by user ids
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindByIds
   * @request GET:/v1/tenant/{tenantId}/users/bulk
   * @deprecated
   * @secure
   */
  findByIds = (
    tenantId: string,
    query?: {
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UserAggregate[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/bulk`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findByIds */
  findByIdsPathGetter = (
    tenantId: string,
    query?: {
      id?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/bulk`, query);

  /**
   * @description Deprecated, use 'query users' - Query User Aggregate Table by user emails
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindByEmails
   * @request GET:/v1/tenant/{tenantId}/users/by-email
   * @deprecated
   * @secure
   */
  findByEmails = (
    tenantId: string,
    query?: {
      email?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UserAggregate[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/by-email`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findByEmails */
  findByEmailsPathGetter = (
    tenantId: string,
    query?: {
      email?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/by-email`, query);

  /**
   * @description Deprecated, use 'query users' - Gets a user row from fire admin User Aggregate Table
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name GetUserAggregate
   * @request GET:/v1/tenant/{tenantId}/user/{userId}
   * @deprecated
   * @secure
   */
  getUserAggregate = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      UserAggregate,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserAggregate */
  getUserAggregatePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}`);

  /**
   * @description Removes a user
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name Remove
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}
   * @deprecated
   * @secure
   */
  remove = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for remove */
  removePathGetter = (tenantId: string, userId: string) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}`);

  /**
   * @description Deprecated, use 'remove users by filter' - Removes users
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name BulkRemoveByFilter
   * @request DELETE:/v1/tenant/{tenantId}/users/by-filter
   * @deprecated
   * @secure
   */
  bulkRemoveByFilter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/by-filter`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkRemoveByFilter */
  bulkRemoveByFilterPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/by-filter`, query);

  /**
   * @description Update user isSuperAdmin
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateIsSuperAdmin
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/super-admin
   * @deprecated
   * @secure
   */
  updateIsSuperAdmin = (
    tenantId: string,
    userId: string,
    data: UpdateIsSuperAdminRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/super-admin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateIsSuperAdmin */
  updateIsSuperAdminPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/super-admin`);

  /**
   * @description Update user roles
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateUserRoles
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/roles
   * @deprecated
   * @secure
   */
  updateUserRoles = (tenantId: string, userId: string, data: UpdateUserRolesRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/roles`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserRoles */
  updateUserRolesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/roles`);

  /**
   * @description Deprecated, use 'update user roles by filter' - Update user roles in bulk
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name BulkUpdateUserRolesByFilter
   * @request POST:/v1/tenant/{tenantId}/users/roles/by-filter
   * @deprecated
   * @secure
   */
  bulkUpdateUserRolesByFilter = (
    tenantId: string,
    data: BulkUpdateUserRolesRequestByFilter,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/roles/by-filter`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUserRolesByFilter */
  bulkUpdateUserRolesByFilterPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/roles/by-filter`, query);

  /**
   * @description Update user licenses
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateLicenses
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/licenses
   * @deprecated
   * @secure
   */
  updateLicenses = (tenantId: string, userId: string, data: UpdateLicensesRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/licenses`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateLicenses */
  updateLicensesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/licenses`);

  /**
   * @description Deprecated, use 'update user licenses by filter' - Update user licenses in bulk - by filter
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name BulkUpdateLicensesByFilter
   * @request POST:/v1/tenant/{tenantId}/users/licenses/by-filter
   * @deprecated
   * @secure
   */
  bulkUpdateLicensesByFilter = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilter,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/licenses/by-filter`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateLicensesByFilter */
  bulkUpdateLicensesByFilterPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/licenses/by-filter`, query);

  /**
   * @description Deprecated, use 'check update user licenses by filter' -Update user licenses in bulk - check by filter
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name CheckBulkUpdateLicensesByFilter
   * @request POST:/v1/tenant/{tenantId}/users/licenses/by-filter/check
   * @deprecated
   * @secure
   */
  checkBulkUpdateLicensesByFilter = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilter,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CheckLicenseUpdateResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/licenses/by-filter/check`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkBulkUpdateLicensesByFilter */
  checkBulkUpdateLicensesByFilterPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/licenses/by-filter/check`, query);

  /**
   * @description Deprecated, use ui-metadata service - Get UI data
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name GetUiData
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/ui-data
   * @deprecated
   * @secure
   */
  getUiData = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      any,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/ui-data`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUiData */
  getUiDataPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/ui-data`);

  /**
   * @description Deprecated, use ui-metadata service - Set UI data
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name SetUiData
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/ui-data
   * @deprecated
   * @secure
   */
  setUiData = (tenantId: string, userId: string, data?: any, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/ui-data`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setUiData */
  setUiDataPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/ui-data`);

  /**
   * @description Deprecated, use 'export users as csv' - Export users as CSV file
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name ExportCsv
   * @request GET:/v1/tenant/{tenantId}/users/csv
   * @deprecated
   * @secure
   */
  exportCsv = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
      /**
       * Access token for the user. Usually not needed. Only needed when some specific GET requests can't be submitted with a body. e.g. at CSV download actions browsers are having a hard time submitting an Authorization header so we have this extension that it can be submitted as a path parameter. Haproxy copies the value into an Authorization header,that's why our endpoints having .serverLogicWithUserAuth() still allow these requests through.
       * @example "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxZDUyNTM3OC0yYTI0LTQ5YmMtOWVmNC01ZmUxYjk4ZWFhMWQiLCJpYXQiOjE3MjgzOTE2NTZ9.VnXWDXT23jaN8zW-MSNE-WxPA-21yfyuzvsouFWE8Qp4im4jVEak2etgSt9wL7eGwe5UhDh04mX6GmewQMwhkmlaUqMmb6a2m9EuFz0HqVkjza4z9ghl8tdvBpl_Aitm4JQKbjRisQx5z3uZB8gSFpNn0ZXtNuDltSTqgIihejQpa3vqVv3HVHcyN4LKAbo2mFSUXMg2sBDuS2V_pxLH69AP7hCkYcxJazd0YT2FDRlP1Lou0U5m6pxiEPmRmBCAPe9TuHeWHAbVVIWAWUB3uQ4Zj6uC4NZbtJvulFH1ZGxuTmy4A5-Mh0oVMs4GBmOrTmD6pwp2hznCRdHwagC6qJCFQaKfCG-S8RqQUSGzkmm5omw-EnBpmQNp1mByBt6VyFf7ElM5fkhWBWxe8E74Uy17cFW3xyrKy1Tfgry3uydT8mSIDnSSi5-pjP_xgIGlKCyXQaiRQ5FFM37Lla8FM8mKMz2oXvi8hwyjzuUaWTcytJVABytKbzSxabPM7IqWWd49HrLjgjaKePaTm17UxdCp3lZ7tKeNxR4VBZWKp0nMs7okiRX78UKmWi0IWEE5LpjDhEKpnjWrqwgTx83TUpdPS5DpxOTAyIjMsXkddT_jvO5rm8crKsbAZ0B0MZLWMPS-ikHJxxBTQzTA1su66NRtgvCP7WYgJArQYrqKnEk"
       */
      access_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for exportCsv */
  exportCsvPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
      /**
       * Access token for the user. Usually not needed. Only needed when some specific GET requests can't be submitted with a body. e.g. at CSV download actions browsers are having a hard time submitting an Authorization header so we have this extension that it can be submitted as a path parameter. Haproxy copies the value into an Authorization header,that's why our endpoints having .serverLogicWithUserAuth() still allow these requests through.
       * @example "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxZDUyNTM3OC0yYTI0LTQ5YmMtOWVmNC01ZmUxYjk4ZWFhMWQiLCJpYXQiOjE3MjgzOTE2NTZ9.VnXWDXT23jaN8zW-MSNE-WxPA-21yfyuzvsouFWE8Qp4im4jVEak2etgSt9wL7eGwe5UhDh04mX6GmewQMwhkmlaUqMmb6a2m9EuFz0HqVkjza4z9ghl8tdvBpl_Aitm4JQKbjRisQx5z3uZB8gSFpNn0ZXtNuDltSTqgIihejQpa3vqVv3HVHcyN4LKAbo2mFSUXMg2sBDuS2V_pxLH69AP7hCkYcxJazd0YT2FDRlP1Lou0U5m6pxiEPmRmBCAPe9TuHeWHAbVVIWAWUB3uQ4Zj6uC4NZbtJvulFH1ZGxuTmy4A5-Mh0oVMs4GBmOrTmD6pwp2hznCRdHwagC6qJCFQaKfCG-S8RqQUSGzkmm5omw-EnBpmQNp1mByBt6VyFf7ElM5fkhWBWxe8E74Uy17cFW3xyrKy1Tfgry3uydT8mSIDnSSi5-pjP_xgIGlKCyXQaiRQ5FFM37Lla8FM8mKMz2oXvi8hwyjzuUaWTcytJVABytKbzSxabPM7IqWWd49HrLjgjaKePaTm17UxdCp3lZ7tKeNxR4VBZWKp0nMs7okiRX78UKmWi0IWEE5LpjDhEKpnjWrqwgTx83TUpdPS5DpxOTAyIjMsXkddT_jvO5rm8crKsbAZ0B0MZLWMPS-ikHJxxBTQzTA1su66NRtgvCP7WYgJArQYrqKnEk"
       */
      access_token?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/csv`, query);

  /**
   * @description Deprecated - use bulk update users by id is admin v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name BulkUpdateIsSuperAdmin
   * @request POST:/v1/tenant/{tenantId}/users/super-admin
   * @deprecated
   * @secure
   */
  bulkUpdateIsSuperAdmin = (tenantId: string, data: BulkUpdateUserIsSuperAdminRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/super-admin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateIsSuperAdmin */
  bulkUpdateIsSuperAdminPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/super-admin`);

  /**
   * @description Deprecated - use bulk update users by id roles v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name BulkUpdateUserRoles
   * @request POST:/v1/tenant/{tenantId}/users/roles
   * @deprecated
   * @secure
   */
  bulkUpdateUserRoles = (tenantId: string, data: BulkUpdateUserRolesRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/roles`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUserRoles */
  bulkUpdateUserRolesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/roles`);

  /**
   * @description Deprecated - use find user assigned licenses v3
   *
   * @tags Admin User Table, User Management Table, UMT, license
   * @name AssignedLicenses
   * @request GET:/v1/tenant/{tenantId}/users/assigned-licenses
   * @deprecated
   * @secure
   */
  assignedLicenses = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      AssignedLicensesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/assigned-licenses`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for assignedLicenses */
  assignedLicensesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/assigned-licenses`);

  /**
   * @description Deprecated - use check tenant license access v3
   *
   * @tags Admin User Table, User Management Table, UMT, license
   * @name TenantCheckLicenses
   * @request GET:/v1/tenant/{tenantId}/check-licenses
   * @deprecated
   * @secure
   */
  tenantCheckLicenses = (
    tenantId: string,
    query?: {
      license?: License[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CheckTenantLicensesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/check-licenses`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for tenantCheckLicenses */
  tenantCheckLicensesPathGetter = (
    tenantId: string,
    query?: {
      license?: License[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/check-licenses`, query);

  /**
   * No description
   *
   * @tags Admin User Table, User Management Table, UMT, license
   * @name GetLicenseUsage
   * @request GET:/v1/tenant/{tenantId}/users/licenses
   * @deprecated
   * @secure
   */
  getLicenseUsage = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      LicenseUsageResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/licenses`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getLicenseUsage */
  getLicenseUsagePathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/licenses`);

  /**
   * @description Deprecated - use bulk update users by id licenses v3
   *
   * @tags Admin User Table, User Management Table, UMT, license
   * @name BulkUpdateLicenses
   * @request POST:/v1/tenant/{tenantId}/users/licenses
   * @deprecated
   * @secure
   */
  bulkUpdateLicenses = (tenantId: string, data: BulkUpdateUserLicensesRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/licenses`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateLicenses */
  bulkUpdateLicensesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/licenses`);

  /**
   * @description Deprecated - use check if bulk update users by id licenses v3 is possible
   *
   * @tags Admin User Table, User Management Table, UMT, license
   * @name CheckBulkUpdateLicensesByIds
   * @request POST:/v1/tenant/{tenantId}/users/licenses/by-ids/check
   * @deprecated
   * @secure
   */
  checkBulkUpdateLicensesByIds = (tenantId: string, data: BulkUpdateUserLicensesRequest, params: RequestParams = {}) =>
    this.request<
      CheckLicenseUpdateResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/licenses/by-ids/check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkBulkUpdateLicensesByIds */
  checkBulkUpdateLicensesByIdsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/licenses/by-ids/check`);

  /**
   * @description Deprecated - use update user onboarding status v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateOnboardingStatus
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/onboarding-status
   * @deprecated
   * @secure
   */
  updateOnboardingStatus = (
    tenantId: string,
    userId: string,
    data: UpdateOnboardingStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/onboarding-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateOnboardingStatus */
  updateOnboardingStatusPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/onboarding-status`);

  /**
   * @description Deprecated - use get user changelog v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name GetUserChangelog
   * @request GET:/v1/tenant/{tenantId}/user-changelog
   * @deprecated
   * @secure
   */
  getUserChangelog = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      userId?: string;
      callerRef?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUserChange,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-changelog`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserChangelog */
  getUserChangelogPathGetter = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      userId?: string;
      callerRef?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-changelog`, query);

  /**
   * @description Deprecated - use get used integrations v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name GetUsedIntegrations
   * @request GET:/v1/tenant/{tenantId}/used-integrations
   * @deprecated
   * @secure
   */
  getUsedIntegrations = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      UserIntegrationsResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/used-integrations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsedIntegrations */
  getUsedIntegrationsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/used-integrations`);

  /**
   * @description Deprecated - use internal check user licenses v3
   *
   * @tags Internal
   * @name CheckLicenses
   * @request GET:/v1/tenant/{tenantId}/users/check-licenses
   * @deprecated
   */
  checkLicenses = (
    tenantId: string,
    query?: {
      license?: License[];
      userId?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CheckLicensesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/check-licenses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkLicenses */
  checkLicensesPathGetter = (
    tenantId: string,
    query?: {
      license?: License[];
      userId?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/check-licenses`, query);

  /**
   * @description Deprecated, use 'find user management table users' - Query UMT user by id
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindUmtUserById
   * @request GET:/v1/tenant/{tenantId}/user-management-table/user/{userId}
   * @deprecated
   * @secure
   */
  findUmtUserById = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      UMTUser,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-management-table/user/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUmtUserById */
  findUmtUserByIdPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-management-table/user/${userId}`);

  /**
   * @description Deprecated, use 'find user management table users' - Query UMT users by ids
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindUmtUsersByIds
   * @request GET:/v1/tenant/{tenantId}/user-management-table/users/bulk
   * @deprecated
   * @secure
   */
  findUmtUsersByIds = (
    tenantId: string,
    query?: {
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UMTUser[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-management-table/users/bulk`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUmtUsersByIds */
  findUmtUsersByIdsPathGetter = (
    tenantId: string,
    query?: {
      id?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-management-table/users/bulk`, query);

  /**
   * @description Deprecated, use 'find user management table users' - Query UMT users by emails
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindUmtUsersByEmails
   * @request GET:/v1/tenant/{tenantId}/user-management-table/users/by-email
   * @deprecated
   * @secure
   */
  findUmtUsersByEmails = (
    tenantId: string,
    query?: {
      email?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UMTUser[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-management-table/users/by-email`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUmtUsersByEmails */
  findUmtUsersByEmailsPathGetter = (
    tenantId: string,
    query?: {
      email?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-management-table/users/by-email`, query);

  /**
   * @description Deprecated, use 'find user management table users' - Query UMT users by filters
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindUmtUsersByFilters
   * @request GET:/v1/tenant/{tenantId}/user-management-table/users/by-filter
   * @deprecated
   * @secure
   */
  findUmtUsersByFilters = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUMTUser,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-management-table/users/by-filter`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUmtUsersByFilters */
  findUmtUsersByFiltersPathGetter = (
    tenantId: string,
    query?: {
      /** @example "nicolas" */
      search?: string;
      /** @example ["nicolas@vandenberghe.biz"] */
      searchEmails?: string[];
      /** @example [123] */
      userIds?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "64ee0722-c7c6-4b48-bc89-356c99f1d25d"
       */
      workspace?: string;
      /** @example "Admin" */
      role?: IsAdmin;
      /** @example ["User","Admin","SpecificWorkspaceManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyWorkspaceManager","SpecificTeamManager(64ee0722-c7c6-4b48-bc89-356c99f1d25d)","AnyTeamManager"] */
      roles?: RoleFilter[];
      /** @example true */
      "chili-cal-org"?: boolean;
      /** @example true */
      "chili-cal-org-free"?: boolean;
      /** @example true */
      "chili-cal-org-paid"?: boolean;
      /** @example true */
      concierge?: boolean;
      /** @example true */
      "concierge-live"?: boolean;
      /** @example true */
      chat?: boolean;
      /** @example true */
      distro?: boolean;
      /** @example true */
      handoff?: boolean;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gong-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "google-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "gotomeeting-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "hubspot-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "microsoft-teams-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "salesforce-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "slack-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "ringcentral-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "webex-connection"?: ConnectionStatus;
      /**
       * Will be deprecated once `connection-status` and `mapping-status` become functional.
       * @example "Connected"
       */
      "zoom-connection"?: ConnectionStatus;
      "mapping-status"?: MappingStatus[];
      /** @example true */
      "is-invited"?: boolean;
      /** @example true */
      "is-invite-sent"?: boolean;
      /** @example ["64ee0722-c7c6-4b48-bc89-356c99f1d25d"] */
      excludedUsers?: string[];
      /**
       * Column name, optionally prepended by '-'. Valid column names: Name, Email, IsSuperAdmin, Salesforce, Hubspot, Google, Microsoft, MicrosoftTeams, SalesforceIntegration, HubspotIntegration, GoogleIntegration, MicrosoftIntegration
       * @example "-Name"
       */
      ordering?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-management-table/users/by-filter`, query);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name ValidateEmails
   * @request POST:/v1/tenant/{tenantId}/users/invites/validate-emails
   * @deprecated
   * @secure
   */
  validateEmails = (tenantId: string, data: ValidateEmailsRequest, params: RequestParams = {}) =>
    this.request<
      ValidateEmailsResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/invites/validate-emails`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for validateEmails */
  validateEmailsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/invites/validate-emails`);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name BulkInvite
   * @request POST:/v1/tenant/{tenantId}/users/invites
   * @deprecated
   * @secure
   */
  bulkInvite = (tenantId: string, data: BulkInviteRequest, params: RequestParams = {}) =>
    this.request<
      BulkInviteResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/invites`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkInvite */
  bulkInvitePathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/invites`);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name ExistToBeInvited
   * @request POST:/v1/tenant/{tenantId}/users/invites/existToBeInvited
   * @deprecated
   * @secure
   */
  existToBeInvited = (tenantId: string, data: BulkSendInviteNotificationsRequest, params: RequestParams = {}) =>
    this.request<
      boolean,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/invites/existToBeInvited`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for existToBeInvited */
  existToBeInvitedPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/invites/existToBeInvited`);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name BulkSendInviteNotifications
   * @request POST:/v1/tenant/{tenantId}/users/invites/notify
   * @deprecated
   * @secure
   */
  bulkSendInviteNotifications = (
    tenantId: string,
    data: BulkSendInviteNotificationsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/invites/notify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkSendInviteNotifications */
  bulkSendInviteNotificationsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/invites/notify`);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name AcceptInvite
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/invite/accept
   * @deprecated
   * @secure
   */
  acceptInvite = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/invite/accept`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for acceptInvite */
  acceptInvitePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/invite/accept`);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name DeclineInvite
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/invite/decline
   * @deprecated
   * @secure
   */
  declineInvite = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/invite/decline`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for declineInvite */
  declineInvitePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/invite/decline`);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name RequestLicense
   * @request POST:/v1/tenant/{tenantId}/users/licenses/request
   * @deprecated
   * @secure
   */
  requestLicense = (tenantId: string, data: RequestLicenseRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/licenses/request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for requestLicense */
  requestLicensePathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/licenses/request`);

  /**
   * @description Deprecated - use v3
   *
   * @tags User Invites
   * @name SendUserRegisteredNotification
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/notify-new-user
   * @deprecated
   * @secure
   */
  sendUserRegisteredNotification = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/notify-new-user`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for sendUserRegisteredNotification */
  sendUserRegisteredNotificationPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/notify-new-user`);

  /**
   * @description Get Tenant details
   *
   * @tags Tenant Details
   * @name GetApiV1TenantTenantid
   * @request GET:/v1/tenant/{tenantId}
   * @secure
   */
  getApiV1TenantTenantid = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantDetail,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantid */
  getApiV1TenantTenantidPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}`);

  /**
   * @description Deprecated, is not needed - Update tenant details
   *
   * @tags Tenant Details
   * @name PostApiV1TenantTenantid
   * @request POST:/v1/tenant/{tenantId}
   * @deprecated
   * @secure
   */
  postApiV1TenantTenantid = (tenantId: string, data: UpdateTenantRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantid */
  postApiV1TenantTenantidPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}`);

  /**
   * @description Claim tenant
   *
   * @tags Tenant Details
   * @name PostApiV1TenantTenantidClaim
   * @request POST:/v1/tenant/{tenantId}/claim
   * @secure
   */
  postApiV1TenantTenantidClaim = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/claim`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidClaim */
  postApiV1TenantTenantidClaimPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/claim`);

  /**
   * @description Deprecated, use branding - Get tenant picture
   *
   * @tags Tenant Details
   * @name GetApiV1TenantTenantidPicture
   * @request GET:/v1/tenant/{tenantId}/picture
   * @deprecated
   * @secure
   */
  getApiV1TenantTenantidPicture = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/picture`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidPicture */
  getApiV1TenantTenantidPicturePathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/picture`);

  /**
   * @description Deprecated, use branding - Update tenant picture
   *
   * @tags Tenant Details
   * @name PutApiV1TenantTenantidPicture
   * @request PUT:/v1/tenant/{tenantId}/picture
   * @deprecated
   * @secure
   */
  putApiV1TenantTenantidPicture = (tenantId: string, data: ImageUploadRequest, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/picture`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidPicture */
  putApiV1TenantTenantidPicturePathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/picture`);

  /**
   * @description Deprecated, use branding - Delete tenant picture
   *
   * @tags Tenant Details
   * @name DeleteApiV1TenantTenantidPicture
   * @request DELETE:/v1/tenant/{tenantId}/picture
   * @deprecated
   * @secure
   */
  deleteApiV1TenantTenantidPicture = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/picture`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidPicture */
  deleteApiV1TenantTenantidPicturePathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/picture`);

  /**
   * @description Deprecated, use branding - Get Tenant details public
   *
   * @tags Public
   * @name TenantDetailGetPublic
   * @request GET:/v1/public/tenant/{tenantId}
   * @deprecated
   */
  tenantDetailGetPublic = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      PublicTenantDetail,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for tenantDetailGetPublic */
  tenantDetailGetPublicPathGetter = (tenantId: string) => this.getServicePath(`/v1/public/tenant/${tenantId}`);

  /**
   * @description Deprecated, use branding - Get tenant picture public
   *
   * @tags Public
   * @name TenantDetailGetPicturePublic
   * @request GET:/v1/public/tenant/{tenantId}/picture
   * @deprecated
   */
  tenantDetailGetPicturePublic = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/picture`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for tenantDetailGetPicturePublic */
  tenantDetailGetPicturePublicPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/picture`);

  /**
   * @description Deprecated, use branding - Get Tenant details - for guests
   *
   * @tags Tenant Details, Guest
   * @name TenantDetailGetGuest
   * @request GET:/v1/guest-external/tenant/{tenantId}
   * @deprecated
   * @secure
   */
  tenantDetailGetGuest = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      PublicTenantDetail,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for tenantDetailGetGuest */
  tenantDetailGetGuestPathGetter = (tenantId: string) => this.getServicePath(`/v1/guest-external/tenant/${tenantId}`);

  /**
   * @description Deprecated, use branding - Get tenant picture - for guests
   *
   * @tags Tenant Details, Guest
   * @name TenantDetailGetPictureGuest
   * @request GET:/v1/guest-external/tenant/{tenantId}/picture
   * @deprecated
   * @secure
   */
  tenantDetailGetPictureGuest = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/picture`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for tenantDetailGetPictureGuest */
  tenantDetailGetPictureGuestPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/picture`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name FindPersonalDetails
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/personal-details
   * @deprecated
   */
  findPersonalDetails = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/personal-details`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findPersonalDetails */
  findPersonalDetailsPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/personal-details`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name FindPersonalDetailsForGuests
   * @request GET:/v1/guest-external/tenant/{tenantId}/user/{userId}/personal-details
   * @deprecated
   * @secure
   */
  findPersonalDetailsForGuests = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-details`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findPersonalDetailsForGuests */
  findPersonalDetailsForGuestsPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-details`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name FindPersonalDetailsPublic
   * @request GET:/v1/public/tenant/{tenantId}/personal-details-by-ids
   * @deprecated
   */
  findPersonalDetailsPublic = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdPersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/personal-details-by-ids`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findPersonalDetailsPublic */
  findPersonalDetailsPublicPathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/personal-details-by-ids`, query);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name FindPersonalDetailsOfListOfUsersForGuests
   * @request GET:/v1/guest-external/tenant/{tenantId}/personal-details-by-ids
   * @deprecated
   * @secure
   */
  findPersonalDetailsOfListOfUsersForGuests = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdPersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/personal-details-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findPersonalDetailsOfListOfUsersForGuests */
  findPersonalDetailsOfListOfUsersForGuestsPathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
  ) => this.getServicePath(`/v1/guest-external/tenant/${tenantId}/personal-details-by-ids`, query);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name FindPersonalDetailsByName
   * @request GET:/v1/tenant/{tenantId}/personal-details-by-name
   * @deprecated
   * @secure
   */
  findPersonalDetailsByName = (
    tenantId: string,
    query: {
      name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdPersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/personal-details-by-name`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findPersonalDetailsByName */
  findPersonalDetailsByNamePathGetter = (
    tenantId: string,
    query: {
      name: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/personal-details-by-name`, query);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name SetPersonalDetails
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/personal-details
   * @deprecated
   * @secure
   */
  setPersonalDetails = (tenantId: string, userId: string, data: PersonalDetails, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/personal-details`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setPersonalDetails */
  setPersonalDetailsPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/personal-details`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name PutPicture
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/personal-details/image
   * @deprecated
   * @secure
   */
  putPicture = (tenantId: string, userId: string, data: ImageUploadRequest, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/personal-details/image`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putPicture */
  putPicturePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/personal-details/image`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name DeletePicture
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/personal-details/image
   * @deprecated
   * @secure
   */
  deletePicture = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/personal-details/image`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deletePicture */
  deletePicturePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/personal-details/image`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name GetPictures
   * @request GET:/v1/public/tenant/{tenantId}/images
   * @deprecated
   */
  getPictures = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdString,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/images`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPictures */
  getPicturesPathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/images`, query);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name GetPicturesGuest
   * @request GET:/v1/guest-external/tenant/{tenantId}/images
   * @deprecated
   * @secure
   */
  getPicturesGuest = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdString,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/images`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPicturesGuest */
  getPicturesGuestPathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
  ) => this.getServicePath(`/v1/guest-external/tenant/${tenantId}/images`, query);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name GetPicture
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/personal-details/image
   * @deprecated
   */
  getPicture = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/personal-details/image`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPicture */
  getPicturePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/personal-details/image`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name GetPictureGuest
   * @request GET:/v1/guest-external/tenant/{tenantId}/user/{userId}/personal-details/image
   * @deprecated
   * @secure
   */
  getPictureGuest = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-details/image`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPictureGuest */
  getPictureGuestPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-details/image`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name GetCustomCompanyLogo
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo
   * @deprecated
   */
  getCustomCompanyLogo = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getCustomCompanyLogo */
  getCustomCompanyLogoPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name GetCustomCompanyLogoGuest
   * @request GET:/v1/guest-external/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo
   * @deprecated
   * @secure
   */
  getCustomCompanyLogoGuest = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getCustomCompanyLogoGuest */
  getCustomCompanyLogoGuestPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name PutCustomCompanyLogo
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo
   * @deprecated
   * @secure
   */
  putCustomCompanyLogo = (tenantId: string, userId: string, data: ImageUploadRequest, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putCustomCompanyLogo */
  putCustomCompanyLogoPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name DeleteCustomCompanyLogo
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo
   * @deprecated
   * @secure
   */
  deleteCustomCompanyLogo = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteCustomCompanyLogo */
  deleteCustomCompanyLogoPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Pages
   * @name GetPersonalPage
   * @request GET:/v1/public/tenant/{tenantId}/user/{userId}/personal-page
   * @deprecated
   */
  getPersonalPage = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalPage,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/user/${userId}/personal-page`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPersonalPage */
  getPersonalPagePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/user/${userId}/personal-page`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Details
   * @name GetPersonalPageForGuests
   * @request GET:/v1/guest-external/tenant/{tenantId}/user/{userId}/personal-page
   * @deprecated
   * @secure
   */
  getPersonalPageForGuests = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalPage,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-page`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPersonalPageForGuests */
  getPersonalPageForGuestsPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/user/${userId}/personal-page`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Pages
   * @name SetPersonalPage
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/personal-page
   * @deprecated
   * @secure
   */
  setPersonalPage = (tenantId: string, userId: string, data: Update1, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/personal-page`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setPersonalPage */
  setPersonalPagePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/personal-page`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Personal Pages
   * @name DeletePersonalPage
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/personal-page
   * @deprecated
   * @secure
   */
  deletePersonalPage = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/personal-page`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deletePersonalPage */
  deletePersonalPagePathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/personal-page`);

  /**
   * @description Deprecated - not used
   *
   * @tags Personal Details
   * @name GetFavoriteMeetingTypes
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/favorite-meeting-types
   * @deprecated
   * @secure
   */
  getFavoriteMeetingTypes = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      FavoriteMeetingTypes,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/favorite-meeting-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getFavoriteMeetingTypes */
  getFavoriteMeetingTypesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/favorite-meeting-types`);

  /**
   * @description Deprecated - not used
   *
   * @tags Personal Details
   * @name SetFavoriteMeetingTypes
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/favorite-meeting-types
   * @deprecated
   * @secure
   */
  setFavoriteMeetingTypes = (
    tenantId: string,
    userId: string,
    data: FavoriteMeetingTypes,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/favorite-meeting-types`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setFavoriteMeetingTypes */
  setFavoriteMeetingTypesPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/favorite-meeting-types`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Org Branding, User Authenticated
   * @name GetApiV1TenantTenantidBranding
   * @request GET:/v1/tenant/{tenantId}/branding
   * @deprecated
   * @secure
   */
  getApiV1TenantTenantidBranding = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      RevisedOrgBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidBranding */
  getApiV1TenantTenantidBrandingPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/branding`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Org Branding, User Authenticated
   * @name PutApiV1TenantTenantidBranding
   * @request PUT:/v1/tenant/{tenantId}/branding
   * @deprecated
   * @secure
   */
  putApiV1TenantTenantidBranding = (tenantId: string, data: OrgBrandingPutRequest, params: RequestParams = {}) =>
    this.request<
      RevisedOrgBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/branding`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidBranding */
  putApiV1TenantTenantidBrandingPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/branding`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Org Branding, User Authenticated
   * @name GetApiV1TenantTenantidLogo
   * @request GET:/v1/tenant/{tenantId}/logo
   * @deprecated
   * @secure
   */
  getApiV1TenantTenantidLogo = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/logo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidLogo */
  getApiV1TenantTenantidLogoPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Org Branding, User Authenticated
   * @name PutApiV1TenantTenantidLogo
   * @request PUT:/v1/tenant/{tenantId}/logo
   * @deprecated
   * @secure
   */
  putApiV1TenantTenantidLogo = (tenantId: string, data: ImageUploadRequest, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/logo`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidLogo */
  putApiV1TenantTenantidLogoPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Org Branding, User Authenticated
   * @name DeleteApiV1TenantTenantidLogo
   * @request DELETE:/v1/tenant/{tenantId}/logo
   * @deprecated
   * @secure
   */
  deleteApiV1TenantTenantidLogo = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/logo`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidLogo */
  deleteApiV1TenantTenantidLogoPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/logo`);

  /**
   * @description Get tenant branding, accessible by any authenticated client, regardless/across of tenant membership
   *
   * @tags Branding, Org Branding, Public
   * @name GetOrgBrandingPublic
   * @request GET:/v1/public/tenant/{tenantId}/branding
   * @deprecated
   */
  getOrgBrandingPublic = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      RevisedOrgBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/branding`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOrgBrandingPublic */
  getOrgBrandingPublicPathGetter = (tenantId: string) => this.getServicePath(`/v1/public/tenant/${tenantId}/branding`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Workspace Branding, User Authenticated
   * @name GetApiV1TenantTenantidWorkspaceWorkspaceidBranding
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/branding
   * @deprecated
   * @secure
   */
  getApiV1TenantTenantidWorkspaceWorkspaceidBranding = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      RevisedWorkspaceBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspaceWorkspaceidBranding */
  getApiV1TenantTenantidWorkspaceWorkspaceidBrandingPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/branding`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Workspace Branding, User Authenticated
   * @name GetApiV1TenantTenantidWorkspaceWorkspaceidLogo
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/logo
   * @deprecated
   * @secure
   */
  getApiV1TenantTenantidWorkspaceWorkspaceidLogo = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/logo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspaceWorkspaceidLogo */
  getApiV1TenantTenantidWorkspaceWorkspaceidLogoPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Workspace Branding, User Authenticated
   * @name PutApiV1TenantTenantidWorkspaceWorkspaceidLogo
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/logo
   * @deprecated
   * @secure
   */
  putApiV1TenantTenantidWorkspaceWorkspaceidLogo = (
    tenantId: string,
    workspaceId: string,
    data: ImageUploadRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/logo`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspaceWorkspaceidLogo */
  putApiV1TenantTenantidWorkspaceWorkspaceidLogoPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Workspace Branding, User Authenticated
   * @name DeleteApiV1TenantTenantidWorkspaceWorkspaceidLogo
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/logo
   * @deprecated
   * @secure
   */
  deleteApiV1TenantTenantidWorkspaceWorkspaceidLogo = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/logo`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidWorkspaceWorkspaceidLogo */
  deleteApiV1TenantTenantidWorkspaceWorkspaceidLogoPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/logo`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Workspace Branding, User Authenticated
   * @name PutApiV1TenantTenantidWorkspaceWorkspaceidBrandingStyle
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/branding/style
   * @deprecated
   * @secure
   */
  putApiV1TenantTenantidWorkspaceWorkspaceidBrandingStyle = (
    tenantId: string,
    workspaceId: string,
    data: Style,
    params: RequestParams = {},
  ) =>
    this.request<
      RevisedOptionStyle,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/branding/style`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspaceWorkspaceidBrandingStyle */
  putApiV1TenantTenantidWorkspaceWorkspaceidBrandingStylePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/branding/style`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Branding, Workspace Branding, User Authenticated
   * @name DeleteApiV1TenantTenantidWorkspaceWorkspaceidBrandingStyle
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/branding/style
   * @deprecated
   * @secure
   */
  deleteApiV1TenantTenantidWorkspaceWorkspaceidBrandingStyle = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      RevisedWorkspaceBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/branding/style`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidWorkspaceWorkspaceidBrandingStyle */
  deleteApiV1TenantTenantidWorkspaceWorkspaceidBrandingStylePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/branding/style`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Public, Branding, Workspace Branding, Applied Branding
   * @name PublicGetWorkspaceAppliedStyling
   * @request GET:/v1/public/tenant/{tenantId}/workspace/{workspaceId}/applied-branding
   * @deprecated
   */
  publicGetWorkspaceAppliedStyling = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      AppliedStyling,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/workspace/${workspaceId}/applied-branding`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publicGetWorkspaceAppliedStyling */
  publicGetWorkspaceAppliedStylingPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/workspace/${workspaceId}/applied-branding`);

  /**
   * @description Deprecated - use v3
   *
   * @tags Guest, Branding, Workspace Branding, Applied Branding
   * @name PublicGetWorkspaceAppliedStylingGuest
   * @request GET:/v1/guest-external/tenant/{tenantId}/workspace/{workspaceId}/applied-branding
   * @deprecated
   * @secure
   */
  publicGetWorkspaceAppliedStylingGuest = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      AppliedStyling,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/workspace/${workspaceId}/applied-branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publicGetWorkspaceAppliedStylingGuest */
  publicGetWorkspaceAppliedStylingGuestPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/workspace/${workspaceId}/applied-branding`);

  /**
   * @description Get a User Provisioning Automation
   *
   * @tags User Provisioning Automation
   * @name ReadUserProvisioningAutomations
   * @request GET:/v1/tenant/{tenantId}/user-provisioning-automation/configurations
   * @secure
   */
  readUserProvisioningAutomations = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      UserProvisioningAutomation[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-provisioning-automation/configurations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for readUserProvisioningAutomations */
  readUserProvisioningAutomationsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-provisioning-automation/configurations`);

  /**
   * @description Create a new User Provisioning Automation
   *
   * @tags User Provisioning Automation
   * @name CreateUserProvisioningAutomation
   * @request POST:/v1/tenant/{tenantId}/user-provisioning-automation/configurations
   * @secure
   */
  createUserProvisioningAutomation = (tenantId: string, data: UpaConfig, params: RequestParams = {}) =>
    this.request<
      UserProvisioningAutomation,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-provisioning-automation/configurations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createUserProvisioningAutomation */
  createUserProvisioningAutomationPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-provisioning-automation/configurations`);

  /**
   * @description Get a User Provisioning Automation
   *
   * @tags User Provisioning Automation
   * @name ReadUserProvisioningAutomation
   * @request GET:/v1/tenant/{tenantId}/user-provisioning-automation/configurations/{id}
   * @secure
   */
  readUserProvisioningAutomation = (tenantId: string, id: string, params: RequestParams = {}) =>
    this.request<
      UserProvisioningAutomation,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for readUserProvisioningAutomation */
  readUserProvisioningAutomationPathGetter = (tenantId: string, id: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}`);

  /**
   * @description Update a User Provisioning Automation
   *
   * @tags User Provisioning Automation
   * @name UpdateUserProvisioningAutomation
   * @request PUT:/v1/tenant/{tenantId}/user-provisioning-automation/configurations/{id}
   * @secure
   */
  updateUserProvisioningAutomation = (tenantId: string, id: string, data: UpaConfig, params: RequestParams = {}) =>
    this.request<
      UserProvisioningAutomation,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserProvisioningAutomation */
  updateUserProvisioningAutomationPathGetter = (tenantId: string, id: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}`);

  /**
   * @description Update a User Provisioning Automation
   *
   * @tags User Provisioning Automation
   * @name DeleteUserProvisioningAutomation
   * @request DELETE:/v1/tenant/{tenantId}/user-provisioning-automation/configurations/{id}
   * @secure
   */
  deleteUserProvisioningAutomation = (tenantId: string, id: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteUserProvisioningAutomation */
  deleteUserProvisioningAutomationPathGetter = (tenantId: string, id: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}`);

  /**
   * @description Trigger a User Provisioning Automation
   *
   * @tags User Provisioning Automation
   * @name TriggerUserProvisioningAutomation
   * @request POST:/v1/tenant/{tenantId}/user-provisioning-automation/configurations/{id}/trigger
   * @secure
   */
  triggerUserProvisioningAutomation = (tenantId: string, id: string, params: RequestParams = {}) =>
    this.request<
      UpaLog,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}/trigger`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for triggerUserProvisioningAutomation */
  triggerUserProvisioningAutomationPathGetter = (tenantId: string, id: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-provisioning-automation/configurations/${id}/trigger`);

  /**
   * @description Preview a new User Provisioning Automation
   *
   * @tags User Provisioning Automation
   * @name PreviewUserProvisioningAutomation
   * @request POST:/v1/tenant/{tenantId}/user-provisioning-automation/preview
   * @secure
   */
  previewUserProvisioningAutomation = (tenantId: string, data: UpaConfig, params: RequestParams = {}) =>
    this.request<
      UpaLog,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-provisioning-automation/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for previewUserProvisioningAutomation */
  previewUserProvisioningAutomationPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-provisioning-automation/preview`);
}
